import gql from 'graphql-tag';
import client from '../../utils/apolloClient';

const aggregateMenuOrderDrilldownQuery = gql`
  query aggregateMenuOrderDrilldownQuery(
    $userId: String
    $placeFilter: PlaceFilter
  ) {
    aggregate_menu_order_drilldown(
      input: { user_id: $userId, filter: { place_filter: $placeFilter } }
    ) {
      place_name
      sales_member_email
      from_date
      to_date
      service_types {
        service_type
        completed_orders
        sum_sale
        avg_sale
        payout
        delivery_fees
        srv_fee
        app_fee
        kravein_fee
        franchise_fee
        royalty_fee
        cancelled_orders
        total_gst
        p_gst
        application_fee_gst
        draft_orders
      }
      aggregate {
        gst
        payment_gateway_fee
        avg_sale
        cancelled_orders
        completed_orders
        sum_sale
        payout
        delivery_fees
        srv_fee
        app_fee
        kravein_fee
        franchise_fee
        royalty_fee
        total_gst
        p_gst
        application_fee_gst
        draft_orders
      }
    }
  }
`;

const aggregateMenuOrderRollupQuery = gql`
  query aggregateMenuOrderRollupQuery(
    $userId: String
    $placeFilter: PlaceFilter
  ) {
    aggregate_menu_order_rollup(
      input: { user_id: $userId, filter: { place_filter: $placeFilter } }
    ) {
      aggregate {
        gst
        payment_gateway_fee
        avg_sale
        cancelled_orders
        completed_orders
        sum_sale
        payout
        delivery_fees
        srv_fee
        app_fee
        kravein_fee
        franchise_fee
        royalty_fee
        total_gst
        p_gst
        application_fee_gst
        draft_orders
      }
      service_types {
        service_type
        completed_orders
        sum_sale
        avg_sale
        payout
        delivery_fees
        srv_fee
        app_fee
        kravein_fee
        franchise_fee
        royalty_fee
        cancelled_orders
        total_gst
        p_gst
        application_fee_gst
        draft_orders
      }
    }
  }
`;

const fetchAggregateMenuOrderDrilldown = async ({
  userId,
  rangeType,
  isCashExclude,
  isTestPlace,
}) => {
  const placeFilter = { range_type: rangeType };

  if (isCashExclude === true) {
    placeFilter.is_cash_exclude = true;
  }
  if (isTestPlace === false) {
    placeFilter.is_test_place = false;
  }
  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: aggregateMenuOrderDrilldownQuery,
      variables: { userId, placeFilter },
      fetchPolicy: 'network-only',
    });
    if (data && data.data && data.data.aggregate_menu_order_drilldown) {
      return data.data.aggregate_menu_order_drilldown;
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const fetchAggregateMenuOrderRollup = async ({
  userId,
  rangeType,
  isCashExclude,
  isTestPlace,
}) => {
  const placeFilter = { range_type: rangeType };

  if (isCashExclude === true) {
    placeFilter.is_cash_exclude = true;
  }
  if (isTestPlace === false) {
    placeFilter.is_test_place = false;
  }
  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: aggregateMenuOrderRollupQuery,
      variables: { userId, placeFilter },
      fetchPolicy: 'network-only',
    });
    if (data && data.data && data.data.aggregate_menu_order_rollup) {
      return [data.data.aggregate_menu_order_rollup];
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const transformDrilldownData = drilldownData => {
  const temp = [];
  (drilldownData ?? []).forEach(ddData => {
    const {
      place_name: venue,
      aggregate,
      service_types,
      sales_member_email,
      from_date,
      to_date,
    } = ddData ?? {};
    const allOrders = aggregate.completed_orders ?? '-';
    const allSales = `$${parseFloat(aggregate?.sum_sale || 0).toFixed(2)}`;
    const payout = `$${parseFloat(aggregate?.payout || 0).toFixed(2)}`;
    const missedOrders = aggregate.cancelled_orders ?? '-';
    const averageSales = `$${parseFloat(aggregate?.avg_sale || 0).toFixed(2)}`;
    const totalGst = `$${parseFloat(aggregate?.total_gst || 0).toFixed(2)}`;
    const pGst = `$${parseFloat(aggregate?.p_gst || 0).toFixed(2)}`;
    const kGst = `$${parseFloat(aggregate?.application_fee_gst || 0).toFixed(
      2,
    )}`;
    const drafts = aggregate?.draft_orders || '-';

    const temp2 = {};
    (service_types ?? []).forEach(st => {
      temp2[st.service_type] = {
        sales: st.sum_sale,
        completed_orders: st.completed_orders,
        totalGst: st?.total_gst,
        pGst: st?.p_gst,
        kGst: st?.application_fee_gst,
      };
    });
    const pickupTotalOrders = temp2?.Pickup?.completed_orders ?? 0;
    const pickupSales = `$${parseFloat(temp2?.Pickup?.sales || 0).toFixed(2)}`;

    const pickupTotalGst = `$${parseFloat(temp2?.Pickup?.totalGst || 0).toFixed(
      2,
    )}`;
    const pickupPGst = `$${parseFloat(temp2?.Pickup?.pGst || 0).toFixed(2)}`;
    const pickupKGst = `$${parseFloat(temp2?.Pickup?.kGst || 0).toFixed(2)}`;

    const dineinTotalOrders = temp2?.Dinein?.completed_orders ?? 0;
    const dineinSales = `$${parseFloat(temp2?.Dinein?.sales || 0).toFixed(2)}`;

    const dineinTotalGst = `$${parseFloat(temp2?.Dinein?.totalGst || 0).toFixed(
      2,
    )}`;
    const dineinPGst = `$${parseFloat(temp2?.Dinein?.pGst || 0).toFixed(2)}`;
    const dineinKGst = `$${parseFloat(temp2?.Dinein?.kGst || 0).toFixed(2)}`;

    const deliveryTotalOrders = temp2?.Delivery?.completed_orders ?? 0;
    const deliverySales = `$${parseFloat(temp2?.Delivery?.sales || 0).toFixed(
      2,
    )}`;
    const deliveryTotalGst = `$${parseFloat(
      temp2?.Delivery?.totalGst || 0,
    ).toFixed(2)}`;
    const deliveryPGst = `$${parseFloat(temp2?.Delivery?.pGst || 0).toFixed(
      2,
    )}`;
    const deliveryKGst = `$${parseFloat(temp2?.Delivery?.kGst || 0).toFixed(
      2,
    )}`;

    temp.push({
      from_date,
      to_date,
      venue,
      salesRep: sales_member_email,
      allOrders,
      allSales,
      payout,
      missedOrders,
      averageSales,
      totalGst,
      pGst,
      kGst,
      drafts,

      pickupTotalOrders,
      pickupSales,
      pickupTotalGst,
      pickupPGst,
      pickupKGst,

      dineinTotalOrders,
      dineinSales,
      dineinTotalGst,
      dineinPGst,
      dineinKGst,

      deliveryTotalOrders,
      deliverySales,
      deliveryTotalGst,
      deliveryPGst,
      deliveryKGst,

      delFees: `$${parseFloat(aggregate?.delivery_fees || 0).toFixed(2)}`,
      kFees: `$${parseFloat(aggregate?.kravein_fee || 0).toFixed(2)}`,
      fFees: `$${parseFloat(aggregate?.franchise_fee || 0).toFixed(2)}`,
      gst: `$${parseFloat(aggregate?.gst || 0).toFixed(2)}`,
      paymentGatewayFee: `$${parseFloat(
        aggregate?.payment_gateway_fee || 0,
      ).toFixed(2)}`,
      appfee: `$${parseFloat(aggregate?.app_fee || 0).toFixed(2)}`,
      srvfee: `$${parseFloat(aggregate?.srv_fee || 0).toFixed(2)}`,
    });
  });
  return temp;
};

// total_gst
// p_gst
// application_fee_gst

const transformRollupData = rollupData => {
  const temp = [];
  (rollupData ?? []).forEach(rData => {
    const { aggregate, service_types } = rData;
    const allOrders = aggregate?.completed_orders ?? '-';
    const allSales = `$${parseFloat(aggregate?.sum_sale || 0).toFixed(2)}`;
    const payout = `$${parseFloat(aggregate?.payout || 0).toFixed(2)}`;
    const missedOrders = aggregate?.cancelled_orders ?? '-';
    const averageSales = `$${parseFloat(aggregate?.avg_sale || 0).toFixed(2)}`;
    const totalGst = `$${parseFloat(aggregate?.total_gst || 0).toFixed(2)}`;
    const drafts = aggregate?.draft_orders || '-';
    const pGst = `$${parseFloat(aggregate?.p_gst || 0).toFixed(2)}`;
    const kGst = `$${parseFloat(aggregate?.application_fee_gst || 0).toFixed(
      2,
    )}`;

    const temp2 = {};
    (service_types ?? []).forEach(st => {
      temp2[st.service_type] = {
        sales: st.sum_sale,
        completed_orders: st.completed_orders,
        totalGst: st?.total_gst,
        pGst: st?.p_gst,
        kGst: st?.application_fee_gst,
      };
    });
    const pickupTotalOrders = temp2?.Pickup?.completed_orders ?? 0;
    const pickupSales = `$${parseFloat(temp2?.Pickup?.sales || 0).toFixed(2)}`;
    const pickupTotalGst = `$${parseFloat(temp2?.Pickup?.totalGst || 0).toFixed(
      2,
    )}`;
    const pickupPGst = `$${parseFloat(temp2?.Pickup?.pGst || 0).toFixed(2)}`;
    const pickupKGst = `$${parseFloat(temp2?.Pickup?.kGst || 0).toFixed(2)}`;

    const dineinTotalOrders = temp2?.Dinein?.completed_orders ?? 0;
    const dineinSales = `$${parseFloat(temp2?.Dinein?.sales || 0).toFixed(2)}`;
    const dineinTotalGst = `$${parseFloat(temp2?.Dinein?.totalGst || 0).toFixed(
      2,
    )}`;
    const dineinPGst = `$${parseFloat(temp2?.Dinein?.pGst || 0).toFixed(2)}`;
    const dineinKGst = `$${parseFloat(temp2?.Dinein?.kGst || 0).toFixed(2)}`;

    const deliveryTotalOrders = temp2?.Delivery?.completed_orders ?? 0;
    const deliverySales = `$${parseFloat(temp2?.Delivery?.sales || 0).toFixed(
      2,
    )}`;
    const deliveryTotalGst = `$${parseFloat(
      temp2?.Delivery?.totalGst || 0,
    ).toFixed(2)}`;
    const deliveryPGst = `$${parseFloat(temp2?.Delivery?.pGst || 0).toFixed(
      2,
    )}`;
    const deliveryKGst = `$${parseFloat(temp2?.Delivery?.kGst || 0).toFixed(
      2,
    )}`;
    temp.push({
      allOrders,
      allSales,
      payout,
      missedOrders,
      averageSales,
      totalGst,
      pGst,
      kGst,
      drafts,

      pickupTotalOrders,
      pickupSales,
      pickupTotalGst,
      pickupPGst,
      pickupKGst,

      dineinTotalOrders,
      dineinSales,
      dineinTotalGst,
      dineinPGst,
      dineinKGst,

      deliveryTotalOrders,
      deliverySales,
      deliveryTotalGst,
      deliveryPGst,
      deliveryKGst,

      delFees: `$${parseFloat(aggregate?.delivery_fees || 0).toFixed(2)}`,
      kFees: `$${parseFloat(aggregate?.kravein_fee || 0).toFixed(2)}`,
      fFees: `$${parseFloat(aggregate?.franchise_fee || 0).toFixed(2)}`,
      gst: `$${parseFloat(aggregate?.gst || 0).toFixed(2)}`,
      paymentGatewayFee: `$${parseFloat(
        aggregate?.payment_gateway_fee || 0,
      ).toFixed(2)}`,
      appfee: `$${parseFloat(aggregate?.app_fee || 0).toFixed(2)}`,
      srvfee: `$${parseFloat(aggregate?.srv_fee || 0).toFixed(2)}`,
    });
  });
  return temp[0];
};

export {
  fetchAggregateMenuOrderDrilldown,
  fetchAggregateMenuOrderRollup,
  transformDrilldownData,
  transformRollupData,
};
